import MultiLevelForm from './MultiLevelForm';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import withValidationData from '../../../hocs/withValidationData';

const buildMultiLevelItems = (items, customisations) => {
  return cloneDeep(items).map(item => {
    item.form.body = item.form.body.map(field => ({
      ...field,
      value: get(customisations, field.name),
    }));

    return item;
  });
};

export default compose(
  withValidationData,
  withProps(({ drawer, queryParams }) => ({
    drawer: {
      ...drawer,
      items: buildMultiLevelItems(drawer.items, queryParams)
    }
  }))
)(MultiLevelForm);
